import React from 'react';

const OnePercent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
      <defs>
        <path id="nv5rsdrl6a" d="M0 0H42V42H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-16 -4126) translate(0 4078) translate(16 48)">
              <mask id="cdm4rtgsub" fill="#fff">
                <use xlinkHref="#nv5rsdrl6a" />
              </mask>
              <g fill="#FFF" mask="url(#cdm4rtgsub)">
                <g>
                  <path
                    d="M28.825 16.648c0-.54-.44-.979-.98-.979s-.979.44-.979.98c0 .539.44.978.98.978s.979-.44.979-.979M33.628 20.635c-.54 0-.979.439-.979.979s.44.98.98.98.979-.44.979-.98-.44-.98-.98-.98"
                    transform="translate(1 1)"
                  />
                  <path
                    d="M33.628 23.832c-1.223 0-2.218-.995-2.218-2.218 0-1.223.995-2.218 2.218-2.218 1.223 0 2.218.995 2.218 2.218 0 1.223-.995 2.218-2.218 2.218zm-7.101.005l6.898-9.45h1.606l-6.898 9.45h-1.606zm-.9-7.189c0-1.223.996-2.218 2.219-2.218 1.223 0 2.219.995 2.219 2.218 0 1.222-.996 2.218-2.22 2.218-1.222 0-2.218-.996-2.218-2.218zm-1.928 18.42h-7.698V11.242l-2.867-.027.023-3.86 3.715-3.307h6.827v31.02zM19.72 0C8.83 0 0 8.829 0 19.721c0 10.891 8.83 19.72 19.72 19.72 10.892 0 19.723-8.829 19.723-19.72C39.443 8.83 30.613 0 19.72 0z"
                    transform="translate(1 1)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default OnePercent;
